function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { api, errText, isAdmin, statusLabel } from "./api";

/*
 * Program lifecycle buttons (§11: submit | approve | reject | start | pause | resume | cancel), driven by the
 * API's nextTransitions so the UI never offers a move the state machine refuses. Approve / reject are
 * Administrator (ACCESS token). Start and Cancel ask for a second click because they touch real people.
 * Every refusal (needsLeads, mailboxesNotActive, lintFailed, needsReview…) is shown verbatim.
 *
 * props: program {id, status}, next (nextTransitions), blocked ({target: reason}: shown disabled with the reason), onDone(result) (reload), compact
 * Optional (2026-10-09 redesign): only (targets to offer, e.g. ["Canceled"]), initialConfirm (open straight on that
 * target's confirm step), onDismiss() (called when the confirm step is closed with Keep), hideBlockedText.
 */

const MOVES = {
  InReview: {
    path: "submit",
    label: "Submit for review",
    tone: "primary"
  },
  Approved: {
    path: "approve",
    label: "Approve",
    admin: true,
    tone: "primary"
  },
  Rejected: {
    path: "reject",
    label: "Reject",
    admin: true,
    reason: true
  },
  Running: {
    path: "start",
    label: "Start sending",
    tone: "primary",
    confirm: "Start sending? Real emails go out to the loaded leads from the chosen mailboxes inside the send window."
  },
  Paused: {
    path: "pause",
    label: "Pause"
  },
  Canceled: {
    path: "cancel",
    label: "Cancel program",
    reason: true,
    confirm: "Cancel this program? Every active lead is stopped and the program cannot be restarted."
  }
};
const ORDER = ["InReview", "Approved", "Rejected", "Running", "Paused", "Canceled"];
export default class Lifecycle extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "move", target => async () => {
      const {
        program
      } = this.props;
      const m = MOVES[target];
      let path = m.path;
      if (target === "Running" && program.status === "Paused") path = "resume";
      const needsConfirm = m.confirm && !(target === "Running" && program.status === "Paused");
      if ((needsConfirm || m.reason) && this.state.confirm !== target) {
        this.setState({
          confirm: target,
          reason: "",
          err: null
        });
        return;
      }
      this.setState({
        busy: target,
        err: null,
        ok: null
      });
      try {
        const body = m.reason ? {
          reason: this.state.reason.trim() || undefined
        } : undefined;
        const r = await api("POST", `/programs/${encodeURIComponent(program.id)}/${path}`, body, {
          admin: !!m.admin
        });
        this.setState({
          busy: null,
          confirm: null,
          ok: r && r.status ? `Now ${statusLabel(r.status).toLowerCase()}.` : "Updated."
        });
        this.props.onDone && this.props.onDone(r);
      } catch (e) {
        this.setState({
          busy: null,
          err: errText(e, "That action failed.")
        });
      }
    });
    this.state = {
      busy: null,
      err: null,
      confirm: props.initialConfirm || null,
      reason: "",
      ok: null
    };
  }
  render() {
    const {
      program,
      next = [],
      blocked,
      only,
      hideBlockedText
    } = this.props;
    const {
      busy,
      err,
      confirm,
      reason,
      ok
    } = this.state;
    const admin = isAdmin();
    const targets = ORDER.filter(t => next.indexOf(t) > -1)
    // Draft → Running only exists with the send-without-review switch; the path through review is the norm.
    .filter(t => !(t === "Running" && program.status === "Draft")).filter(t => !MOVES[t].admin || admin).filter(t => !only || only.indexOf(t) > -1);
    const label = t => t === "Running" && program.status === "Paused" ? "Resume" : MOVES[t].label;
    if (!targets.length && !err) return null;
    const c = confirm ? MOVES[confirm] : null;
    return /*#__PURE__*/React.createElement("div", {
      className: "or-lifecycle"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, targets.map(t => /*#__PURE__*/React.createElement(Button, {
      key: t,
      themeColor: MOVES[t].tone === "primary" ? "primary" : "base",
      disabled: !!busy || !!(blocked && blocked[t]),
      title: blocked && blocked[t] ? blocked[t] : undefined,
      onClick: this.move(t)
    }, busy === t ? "…" : label(t))), program.status === "InReview" && !admin ? /*#__PURE__*/React.createElement("span", {
      className: "mini"
    }, "Waiting for an Administrator to approve.") : null, blocked && !hideBlockedText ? targets.filter(t => blocked[t]).map(t => /*#__PURE__*/React.createElement("span", {
      key: t,
      className: "mini"
    }, blocked[t])) : null), c ? /*#__PURE__*/React.createElement("div", {
      className: "ec-confirm or-confirm"
    }, /*#__PURE__*/React.createElement("span", null, c.confirm || (confirm === "Rejected" ? "Reject with a reason the author will see:" : "Reason (optional):")), c.reason ? /*#__PURE__*/React.createElement("input", {
      className: "ec-input",
      value: reason,
      placeholder: "reason",
      onChange: e => this.setState({
        reason: e.target.value
      })
    }) : null, /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      disabled: !!busy,
      onClick: this.move(confirm)
    }, busy ? "…" : `Yes, ${label(confirm).toLowerCase()}`), /*#__PURE__*/React.createElement(Button, {
      disabled: !!busy,
      onClick: () => {
        this.setState({
          confirm: null
        });
        if (this.props.onDismiss) this.props.onDismiss();
      }
    }, "Keep")) : null, err ? /*#__PURE__*/React.createElement("div", {
      className: "wa-notice danger or-err"
    }, err) : null, ok && !err ? /*#__PURE__*/React.createElement("div", {
      className: "mini"
    }, ok) : null);
  }
}